import React from "react";
import {
  FaCalendarCheck,
  FaCalendarTimes,
  FaEuroSign,
  FaEye,
  FaTrash,
  FaUser,
} from "react-icons/fa";

import {
  formatCurrency,
  formatDateFr,
  getPaymentLabel,
  getPaymentStyle,
  getRenewalMessage,
  getRenewalStatusLabel,
  getRenewalStatusStyle,
  getSubscriptionAmount,
  getSubscriptionExpiryDate,
  getSubscriptionFormula,
  getSubscriptionPurchaseDate,
  getSubscriptionUserEmail,
  getSubscriptionUserName,
} from "../utils/adminSubscriptionsUtils";

function SubscriptionsTable({ subscriptions = [], onOpen, onDelete }) {
  return (
    <section className="hidden overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 lg:block">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1180px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Client</th>
              <th className="px-4 py-3">Formule</th>
              <th className="px-4 py-3">Achat</th>
              <th className="px-4 py-3">Échéance</th>
              <th className="px-4 py-3">Renouvellement</th>
              <th className="px-4 py-3">Paiement</th>
              <th className="px-4 py-3">Montant</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {subscriptions.map((subscription) => (
              <tr
                key={subscription.id}
                className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
              >
                <td className="px-4 py-3">
                  <div className="flex min-w-[260px] items-center gap-3">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-700 to-sky-600 text-white shadow-lg shadow-slate-200 dark:shadow-black/30">
                      <FaUser />
                    </div>

                    <div className="min-w-0">
                      <p className="truncate font-bold text-slate-950 dark:text-white">
                        {getSubscriptionUserName(subscription)}
                      </p>

                      <p className="mt-0.5 truncate text-xs font-semibold text-slate-400">
                        {getSubscriptionUserEmail(subscription)}
                      </p>
                    </div>
                  </div>
                </td>

                <td className="px-4 py-3">
                  <p className="max-w-[260px] truncate font-bold text-slate-700 dark:text-white/80">
                    {getSubscriptionFormula(subscription)}
                  </p>
                </td>

                <td className="px-4 py-3">
                  <p className="inline-flex items-center gap-2 text-xs font-bold text-slate-500 dark:text-white/50">
                    <FaCalendarCheck className="text-slate-300" />
                    {formatDateFr(getSubscriptionPurchaseDate(subscription))}
                  </p>
                </td>

                <td className="px-4 py-3">
                  <p className="inline-flex items-center gap-2 text-xs font-bold text-slate-500 dark:text-white/50">
                    <FaCalendarTimes className="text-slate-300" />
                    {formatDateFr(getSubscriptionExpiryDate(subscription))}
                  </p>
                </td>

                <td className="px-4 py-3">
                  <div className="space-y-1">
                    <span
                      className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getRenewalStatusStyle(
                        subscription,
                      )}`}
                    >
                      {getRenewalStatusLabel(subscription)}
                    </span>

                    <p className="text-xs font-semibold text-slate-400">
                      {getRenewalMessage(subscription)}
                    </p>
                  </div>
                </td>

                <td className="px-4 py-3">
                  <span
                    className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getPaymentStyle(
                      subscription,
                    )}`}
                  >
                    {getPaymentLabel(subscription)}
                  </span>
                </td>

                <td className="px-4 py-3">
                  <p className="inline-flex items-center gap-2 font-bold text-slate-700 dark:text-white/80">
                    <FaEuroSign className="text-slate-300" />
                    {formatCurrency(getSubscriptionAmount(subscription))}
                  </p>
                </td>

                <td className="px-4 py-3 text-right">
                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => onOpen(subscription)}
                      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
                    >
                      <FaEye />
                      Détails
                    </button>

                    <button
                      type="button"
                      onClick={() => onDelete(subscription.id)}
                      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl border border-red-200 bg-red-50 px-4 py-2 text-xs font-bold text-red-700 transition hover:-translate-y-0.5 hover:bg-red-100 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-200"
                    >
                      <FaTrash />
                      Supprimer
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default SubscriptionsTable;